import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    public auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    const questionSplit = this.router.url.split("?");
    if (questionSplit.length === 1) {
      this.auth.login();
    } else if (questionSplit.length > 1) {
      setTimeout(() => { // Timeout handles cases where the redirect doesn't trigger. There is a case where it gets called after login and it throws an error, but nothing bad happens.
        if (!this.auth.isLoggedIn) {
          this.auth.login();
        }
      }, 2000); // If the user is stuck waiting for 2 seconds, directly trigger the login.
    }
  }
}
